module.exports = __webpack_public_path__ + "01_veryshort_beige.2e7d99ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_veryshort_beige.png
// module id = c+FZ
// module chunks = 0